const DEFAULT_THRESHOLD = 8;

export class ContributorBlock {
    container: HTMLElement;
    items: HTMLElement[];
    filterOptions: HTMLInputElement[];
    loadMoreBtn: HTMLButtonElement;
    showLessBtn: HTMLButtonElement;
    activeFilters: Set<string>;
    isExpanded: boolean;
    threshold: number;

    constructor(container: HTMLElement) {
        this.container = container;
        this.items = Array.from(container.querySelectorAll<HTMLElement>('[data-item-categories]'));
        this.activeFilters = new Set();
        this.isExpanded = false;
        this.threshold = DEFAULT_THRESHOLD;
        this.filterOptions = Array.from(container.querySelectorAll('input[type="radio"]')) as HTMLInputElement[];
        this.loadMoreBtn = container.querySelector('[data-contributor-more]') as HTMLButtonElement;
        this.showLessBtn = container.querySelector('[data-contributor-less]') as HTMLButtonElement;

        this.filterOptions.forEach(option => {
            option.addEventListener('change', this.onFilterChange.bind(this));
        });

        if (this.loadMoreBtn) {
            this.loadMoreBtn.addEventListener('click', this.onLoadMore.bind(this));
        }
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', this.onShowLess.bind(this));
        }

        this.render();
    }

    onFilterChange(e: Event) {
        this.filterOptions.forEach(option => {
            const category = option.value;
            if (this.activeFilters.has(category) && !option.checked) {
                this.activeFilters.delete(category);
            } else if (option.checked && !this.activeFilters.has(category)) {
                this.activeFilters.add(category);
            }
        });

        this.isExpanded = false;
        this.render();
    }

    getFilteredItems(): HTMLElement[] {
        if (this.activeFilters.size === 0) {
            return this.items;
        }

        return this.items.filter(item => {
            const categories = (item.getAttribute('data-item-categories') || '')
                .split(',')
                .map(c => c.trim())
                .filter(c => c.length > 0)
                .concat("all");

            const matchesFilters = categories.some(cat => this.activeFilters.has(cat));
            return matchesFilters;
        });
    }

    private render() {
        const filtered = this.getFilteredItems();

        this.items.forEach(item => {
            item.hidden = true;
        });

        filtered.forEach((item, index) => {
            item.hidden = !this.isExpanded && index >= this.threshold;
        });

        if (this.loadMoreBtn) {
            this.loadMoreBtn.hidden = this.isExpanded || filtered.length <= this.threshold;
        }
        if (this.showLessBtn) {
            this.showLessBtn.hidden = !this.isExpanded || filtered.length <= this.threshold;
        }
    }

    onLoadMore() {
        this.isExpanded = true;
        this.render();
    }

    onShowLess() {
        this.isExpanded = false;
        this.render();
    }
}
